/* Layout */
import Layout from '@/views/layout/Layout';
export default [
  {
    path: '/healthManagement',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '健康管理',
      icon: 'component',
    },
    children: [
      // {
      //   path: '/healthManagement/userList',
      //   component: () => import('@/myviews/AH_healthManagement/userList/userList'),
      //   alwaysShow: false,
      //   name: '用户列表',
      //   meta: {
      //     title: '用户列表',
      //     icon: 'user',
      //     roles: ['add',"modify","viewpage"],//添加   修改   查看页面
      //     have:[],
      //   }
      // },
      {
        path: '/healthManagement/dataManagement',
        component: () => import('@/myviews/AH_healthManagement/dataManagement/dataManagement'),
        alwaysShow: false,
        name: '健康数据管理',
        meta: {
          title: '健康数据管理',
          icon: 'chart',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      },
    ]
  },
  {
    path: '/healthManagement',
    component: Layout,
    notShow:true,
    alwaysShow: false,
    meta: {
      title: '用户详情',
      icon: 'component',
    },
    children: [
      {
        path: '/healthManagement/ihUserDetails',
        component: () => import('@/myviews/AH_healthManagement/userDetails/ihUserDetails'),
        alwaysShow: false,
        name: '用户列表',
        meta: {
          title: '用户列表',
          icon: 'user',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      }
    ]
  },
  {
    path: '/healthManagement',
    component: Layout,
    notShow:true,
    alwaysShow: false,
    meta: {
      title: '用户详情',
      icon: 'component',
    },
    children: [
      {
        path: '/healthManagement/userPSTDetails',
        component: () => import('@/myviews/AH_healthManagement/userPrescription/userPSTDetails'),
        alwaysShow: false,
        name: '',
        meta: {
          title: '',
          icon: 'user',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      }
    ]
  },
  {
    path: '/healthManagement',
    component: Layout,
    notShow:true,
    alwaysShow: false,
    meta: {
      title: '用户详情',
      icon: 'component',
    },
    children: [
      {
        path: '/healthManagement/userVORDetails',
        component: () => import('@/myviews/AH_healthManagement/userVisitorder/userVORDetails'),
        alwaysShow: false,
        name: '',
        meta: {
          title: '',
          icon: 'user',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      }
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/nurseManage/AH_healthManagement.js